import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import {
  BalanceOpBalNet,
  OpBalNetFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/BalanceSheet/BalanceSheetSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function Statement({ selectedIds, Fromdate, ToDate }) {
  const dispatch = useDispatch();

  const { OpBalNetdata } = useSelector((state) => state.BalanceSheetSlice);
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(
      FilterMain({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
      }),
    );
  }, [dispatch, Firm]);

  useEffect(() => {
    dispatch(OpBalNetFan());
    dispatch(
      BalanceOpBalNet({
        Firm,
        Year: YearId,
        selectedIds: selectedIds || "",
        ToDate,
        Fromdate,
      }),
    );
  }, [dispatch, Firm, YearId, selectedIds, ToDate, Fromdate]);

  const formatIndianAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0.00";
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  const getRows =
    OpBalNetdata?.Detail?.map((label, index) => ({
      srNumber: index + 1,
      AcName: label.AcName,
      Groupseq: label.Groupseq,
      AcLaieName: label.AcLaieName,
      GroupMstName: label.GroupMstName,
      OpCrAmt: label.OpCrAmt,
      OpDrAmt: label.OpDrAmt,
      TriCrAmt: label.TriCrAmt,
      TriDrAmt: label.TriDrAmt,
      NetBalCrAmt: label.NetBalCrAmt,
      NetBalDrAmt: label.NetBalDrAmt,
    })) || [];

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },

    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
      width: "180px",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Group Sequence", key: "Groupseq", align: "left" },
    { label: "Opening Debit", key: "OpDrAmt", align: "right", format: true },
    { label: "Opening Credit", key: "OpCrAmt", align: "right", format: true },
    {
      label: "Transaction Debit",
      key: "TriDrAmt",
      align: "right",
      format: true,
    },
    {
      label: "Transaction Credit",
      key: "TriCrAmt",
      align: "right",
      format: true,
    },
    {
      label: "NetBalance Debit",
      key: "NetBalDrAmt",
      align: "right",
      format: true,
    },
    {
      label: "NetBalance Credit",
      key: "NetBalCrAmt",
      align: "right",
      format: true,
    },
  ];
  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Statement Report", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    /* ================= FIRM NAME ================= */
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(firmName, pageWidth / 2, 25, {
      align: "center",
    });

    let yPos = 35;

    /* ================= TABLE DATA ================= */
    const tableRows = getRows.map((row) => [
      row.srNumber,
      row.AcLaieName || "",
      row.GroupMstName || "",
      row.AcName || "",
      row.Groupseq || "",
      formatIndianAmount(row.OpDrAmt),
      formatIndianAmount(row.OpCrAmt),
      formatIndianAmount(row.TriDrAmt),
      formatIndianAmount(row.TriCrAmt),
      formatIndianAmount(row.NetBalDrAmt),
      formatIndianAmount(row.NetBalCrAmt),
    ]);

    /* ================= TOTAL ================= */
    const totals = getRows.reduce(
      (acc, row) => {
        acc.OpDr += Number(row.OpDrAmt || 0);
        acc.OpCr += Number(row.OpCrAmt || 0);
        acc.TrDr += Number(row.TriDrAmt || 0);
        acc.TrCr += Number(row.TriCrAmt || 0);
        acc.NetDr += Number(row.NetBalDrAmt || 0);
        acc.NetCr += Number(row.NetBalCrAmt || 0);

        return acc;
      },
      {
        OpDr: 0,
        OpCr: 0,
        TrDr: 0,
        TrCr: 0,
        NetDr: 0,
        NetCr: 0,
      },
    );

    tableRows.push([
      "",
      "",
      "",
      "TOTAL",
      "",
      formatIndianAmount(totals.OpDr),
      formatIndianAmount(totals.OpCr),
      formatIndianAmount(totals.TrDr),
      formatIndianAmount(totals.TrCr),
      formatIndianAmount(totals.NetDr),
      formatIndianAmount(totals.NetCr),
    ]);

    /* ================= TABLE ================= */
    autoTable(doc, {
      startY: yPos,

      head: [
        [
          "Sr No.",
          "Ac Type",
          "AcGroup Name",
          "Account Name",
          "Group Sequence",
          "Opening Debit",
          "Opening Credit",
          "Transaction Debit",
          "Transaction Credit",
          "NetBalance Debit",
          "NetBalance Credit",
        ],
      ],

      body: tableRows,
      theme: "grid",
      showHead: "everyPage",

      styles: {
        fontSize: 8,
        valign: "middle",
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.2,
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      bodyStyles: {
        fontStyle: "bold",
      },

      columnStyles: {
        0: { halign: "center", cellWidth: 12 },
        1: { halign: "left", cellWidth: 24 },
        2: { halign: "left", cellWidth: 35 },
        3: { halign: "left", cellWidth: 42 },
        4: { halign: "center", cellWidth: 15 },
        5: { halign: "right", cellWidth: 25 },
        6: { halign: "right", cellWidth: 25 },
        7: { halign: "right", cellWidth: 25 },
        8: { halign: "right", cellWidth: 25 },
        9: { halign: "right", cellWidth: 25 },
        10: { halign: "right", cellWidth: 25 },
      },

      didParseCell(data) {
        if (data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },

      didDrawPage() {
        const pageNo = doc.internal.getCurrentPageInfo().pageNumber;

        doc.setFontSize(8);
        doc.text(`Page ${pageNo}`, marginX, pageHeight - 5);
      },
    });

    /* ================= SAVE ================= */
    doc.save("Statement_Report.pdf");
  };

  if (OpBalNetdata === "no" || OpBalNetdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Download PDF
        </button>
      </div>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
            position: "relative",
            zIndex: 2,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            STATEMENT
          </h2>
        </div>

        {/* <FASparentMultipalChild
          data={getRows}
          columns={getColumns}
          externalTotals={OpBalNetdata?.Summary?.[0]}
        /> */}
        <FASparentMultipalChild
          data={getRows}
          columns={getColumns}
          externalTotals={OpBalNetdata?.Summary?.[0] || {}}
        />
      </div>
    </div>
  );
}
